// The stridy.com site navigation, mirrored here so the dashboard carries the
// same header as the rest of the site. Single source of truth for both the
// desktop bar (SiteHeader.vue) and the mobile burger menu (App.vue).
//
// `current: true` marks the entry this dashboard IS, so it renders in the
// active state the way the live site marks the page you're on.

export const SITE_URL = "https://stridy.com/";

// Height (px) of the site-nav row. The single tunable for it: SiteHeader.vue
// applies it inline, and App.vue adds it to the app-bar height (which is what
// offsets <v-main> and how far the bar slides up on scroll).
export const SITE_HEADER_PX = 120;

export const SITE_NAV = [
  { label: "Events", href: "https://stridy.com/events" },
  {
    label: "Impact",
    href: "https://stridy.com/community-impact-dashboard/",
    current: true,
  },
  { label: "Shop", href: "https://stridy.com/shop" },
  { label: "Articles", href: "https://stridy.com/articles/" },
  {
    label: "About",
    children: [
      { label: "About Stridy", href: "https://stridy.com/about-stridy/" },
      { label: "Our Team", href: "https://stridy.com/our-team/" },
      {
        label: "About Stridy App",
        href: "https://stridy.com/about-stridy-app/",
      },
      { label: "Contact Us", href: "https://stridy.com/contact-us/" },
    ],
  },
];

export const SITE_ACCOUNT_URL = "https://stridy.com/login/";

// The wordmark served by the site itself, at its 600px-wide variant (the full
// asset is 6000px). Kept remote so it tracks whatever the site is serving.
export const SITE_LOGO_SRC =
  "https://stridy.com/wp-content/uploads/2022/02/IMG_2815-600x123.png";
export const SITE_LOGO_SRCSET =
  "https://stridy.com/wp-content/uploads/2022/02/IMG_2815-600x123.png 600w, " +
  "https://stridy.com/wp-content/uploads/2022/02/IMG_2815-1024x211.png 1024w";
